// Reveals an element by animating it up into its resting position the
// first time it scrolls into view. (see Landing2Vision.vue etc for usage).
//
// Mutating the passed DOM element is the entire point of a directive, so
// no-param-reassign is disabled for this file rather than per-line.
/* eslint-disable no-param-reassign */
const OFFSET = '1.5rem'; // 24px
const DURATION = '0.6s';
const THRESHOLD = 0.15;

function prefersReducedMotion() {
  return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export default {
  inserted(el) {
    if (prefersReducedMotion()) return;

    el.style.transform = `translateY(${OFFSET})`;
    el.style.opacity = '0';
    el.style.transition = `transform ${DURATION} ease-out, opacity ${DURATION} ease-out`;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          el.style.transform = 'translateY(0)';
          el.style.opacity = '1';
          observer.unobserve(el);
        }
      });
    }, { threshold: THRESHOLD });

    observer.observe(el);
    el.scrollRevealObserver = observer;
  },
  unbind(el) {
    if (el.scrollRevealObserver) {
      el.scrollRevealObserver.disconnect();
      delete el.scrollRevealObserver;
    }
  },
};
